import React, {forwardRef, useImperativeHandle, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Form, Input, Modal, Radio, Select} from 'antd';
import {useApps} from '@/page/admin/TagsPage/useTagsService';
import {addAppTag, updateAppTag} from '@/api/apptag';

const AppTagFormModal = forwardRef(({reload}, ref) => {
    const formRef = useRef();
    const [visible, setVisible] = useState(false);
    const [appTag, setAppTag] = useState(null);

    const adType = useRef(1);
    console.log('appTag', appTag);

    const {value} = useApps();
    const apps = value?.data ?? [];

    function showModal(tag) {
        setVisible(true);
        setAppTag(tag);

        adType.current = tag?.adType ?? 1;
    }

    function closeModal() {
        setVisible(false);
        setAppTag(null);
    }

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    function isAdd() {
        return !appTag?.id;
    }

    function onOk() {
        formRef.current.submit();
    }

    function onFinish(values) {
        console.log('Received values of form: ', values);
        const promise = isAdd() ? addAppTag(values) : updateAppTag(appTag.id, values);
        promise.then(data => {
            console.log(data);
            reload && reload();
            if(data.success){
                closeModal();
            }
        });
    }

    return (
        <Modal
            destroyOnClose
            maskClosable={false}
            visible={visible}
            title={(isAdd() ? '添加' : '修改') + '标签'}
            onCancel={closeModal}
            onOk={onOk}
        >
            <Form ref={formRef} onFinish={onFinish} layout="vertical" initialValues={appTag}>
                <Form.Item hidden name="id">
                    <Input />
                </Form.Item>

                <Form.Item hidden name="adType">
                    <Input />
                </Form.Item>

                <Form.Item
                    name="name"
                    label="标签名称"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input
                        placeholder="外部应用名称"
                        autoFocus
                        maxLength={30}
                        disabled={!isAdd()}
                    />
                </Form.Item>

                {adType.current === 1 && (
                    <>
                        <Form.Item
                            name="tagGroup"
                            label="标签类别"
                            rules={[
                                {
                                    required: true,
                                },
                            ]}
                        >
                            <Radio.Group disabled={!isAdd()}>
                                <Radio value={0}>用户可见范围组</Radio>
                                <Radio value={1}>应用管理员组</Radio>
                            </Radio.Group>
                        </Form.Item>
                        {isAdd() && (
                            <Form.Item
                                name="appId"
                                label="所属应用"
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择应用',
                                    },
                                ]}
                            >
                                <Select>
                                    {apps.map(({id, name}) => (
                                        <Select.Option key={id} value={id}>
                                            {name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        )}
                    </>
                )}

                <Form.Item
                    name="groupId"
                    label="AD Group Id"
                    extra="多个 group id 使用「逗号」分隔"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input placeholder="AD Group Id" maxLength={1000} />
                </Form.Item>

                <Form.Item style={{display: 'none'}}>
                    <Button type="primary" htmlType="submit" />
                </Form.Item>
            </Form>
        </Modal>
    );
});

AppTagFormModal.displayName = 'AppTagFormModal';

AppTagFormModal.propTypes = {
    reload: PropTypes.func,
};

export default AppTagFormModal;
